import { createSlice } from '@reduxjs/toolkit';

const initialState = localStorage.getItem('language') || 'en';

const languageSlice = createSlice({
	name: 'language',
	initialState,
	reducers: {
		changeLanguage: (state) => (state === 'en' ? 'ar' : 'en'),
	},
});

export const { changeLanguage } = languageSlice.actions;

export default languageSlice.reducer;
